<template>
  <div class="teacher-work-box teacher-work-bg flex-column-between">

    <header class="flex-align-between teacher-head">
      <div class="flex-align-center title-box">
        <img alt="" class="ico" src="@/assets/teacher/h1-title-ico.png">
        <span class="text">投影与测评</span>
      </div>

      <div class="flex-align-center right-button">
        <div class="flex-align-center back-box" @click="goBack">
          <img alt="" class="back-ico" src="@/assets/teacher/back-ico.png">
          <span class="back-text">返回</span>
        </div>
      </div>
    </header>

    <div class="content-box flex-1">
      <div class="select-class flex-column-center">
        <div class="select-h1-title">
          班级同步测评
        </div>

        <div class="select-box">
          <div class="anti-scale">
            <div class="custom-select" :class="{ open: dropdownOpen }">
              <div class="select-trigger flex-align-between" @click="toggleDropdown">
                <span v-if="!selectedClassId" class="placeholder">请选择班级</span>
                <span v-else class="selected-text">{{ selectedClassName }}</span>
                <span class="flex-align-center">
                  <img v-if="selectedClassId" class="clear-btn" @click.stop="clearSelection" src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMjgiIGhlaWdodD0iMTI4IiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxnIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzIxQkQ5OSIgc3Ryb2tlLXdpZHRoPSIxLjUiPjxjaXJjbGUgY3g9IjEyIiBjeT0iMTIiIHI9IjEwIi8+PHBhdGggc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBkPSJtMTQuNSA5LjVsLTUgNW0wLTVsNSA1Ii8+PC9nPjwvc3ZnPg==" alt="">
                  <img class="arrow" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAASCAMAAAAJ4/xdAAAAXVBMVEUAAACqqqqZmZmZmZmZmZmZmZmZmZmZmZmZmZmampqYmJiXl5eZmZmZmZmZmZmZmZmampqZmZmZmZmampqZmZmZmZmZmZmZmZmYmJidnZ2ZmZmampqZmZmZmZmZmZlnMBvsAAAAHnRSTlMABPbqPd3SnzAlGQnxw7R5Xg+vjEy7jmtPE+TJxacR+1gQAAAAr0lEQVQoz3WRVxKDMAxE5YIxmN5J0f2PGYkhEIi1P1Z5M5K1AL7KQVTmLIA1mGQS4Q3qAV6IaHycsAU1R2hLegobIwZNrU4BhIoCvfwTDROp4lClSGruxMzV6Zv1nNVXoj5rZ97/EhNX5stcPOYes/Vt9sK7VWEnOiaG6A3KlsMwCnfwhhqOzFif4jWzBJHMyB09D8GTrWk2UHSWzWC5FUSFDvelZan0+Lqs/q1ulQ/o9w+a6BY23QAAAABJRU5ErkJggg==" alt="">
                </span>
              </div>
              <div class="dropdown" v-show="dropdownOpen">
                <div class="search-box">
                  <input v-model.trim="searchText" type="text" placeholder="输入关键字筛选" class="search-input" />
                </div>
                <div class="loading" v-if="loadingClasses">加载中...</div>
                <ul class="option-list" v-else>
                  <li class="option-item" v-for="(item, index) in filteredClasses" :key="item.id" @click="selectOption(item)">
                    {{ item.name }}
                  </li>
                  <li class="option-item empty" v-if="!filteredClasses.length">无数据</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div class="select-button" @click="confirmSelection">确定</div>

      </div>
    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      writeCount: null,
      classList: [],
      selectedClassId: '',
      loadingClasses: false,
      dropdownOpen: false,
      searchText: '',
    };
  },
  components: {
  },
  computed: {
    selectedClassName() {
      const found = this.classList.find(item => item.id === this.selectedClassId);
      return found ? found.name : '';
    },
    filteredClasses() {
      if (!this.searchText) return this.classList;
      const kw = this.searchText.toLowerCase();
      return this.classList.filter(item => (item.name || '').toLowerCase().includes(kw));
    }
  },
  //方法
  methods: {
    toggleDropdown() {
      this.dropdownOpen = !this.dropdownOpen;
    },
    selectOption(item) {
      this.selectedClassId = item.id;
      this.dropdownOpen = false;
    },
    clearSelection() {
      this.selectedClassId = '';
      this.searchText = '';
    },
    handleClickOutside(e) {
      const root = this.$el && this.$el.querySelector('.custom-select');
      if (this.dropdownOpen && root && !root.contains(e.target)) {
        this.dropdownOpen = false;
      }
    },

    async confirmSelection() {
      if (!this.selectedClassId) {
        if (this.$message) {
          this.$message.warning('请先选择班级');
        }
        return;
      }

      // 获取选中的班级数据
      const selectedClass = this.classList.find(item => item.id === this.selectedClassId);

      try {
        // 发送POST请求创建班级测评
        const lessonId = Math.floor(Date.now() / 1000)
        const res = await this.$Api.CopyBook.createClassTest({
          classId: this.selectedClassId,
          lessonId: lessonId
        });

        if (res && res.code === 200 && res.data && res.data) {
          // 将选择的班级数据存储到sessionStorage
          const classData = {
            classId: this.selectedClassId,
            className: selectedClass ? selectedClass.name : '',
            testId: res.data,
            lessonId: lessonId,
            timestamp: Date.now()
          };
          sessionStorage.setItem('selectedClassData', JSON.stringify(classData));
          sessionStorage.setItem('testId', JSON.stringify(res.data));

          // 成功后跳转到classRoster页面，传递classId和testId
          this.$router.push({
            name: 'classRoster',
            query: {
              classId: this.selectedClassId,
              testId: res.data
            }
          });
        } else {
          if (this.$message) {
            this.$message.error((res && res.msg) || '创建班级测评失败');
          }
        }
      } catch (e) {
        if (this.$message) {
          this.$message.error('创建班级测评失败');
        }
      }
    },


    goBack() {
      if (this.$router && typeof this.$router.back === 'function') {
        this.$router.back();
      } else {
        window.history.back();
      }
    },
    async loadClasses() {
      try {
        this.loadingClasses = true;
        const res = await this.$Api.CopyBook.queryTeacherClasses();
        if (res && res.code === 200 && Array.isArray(res.data)) {
          this.classList = res.data;
        } else {
          this.classList = [];
          if (this.$message) {
            this.$message.error((res && res.msg) || '获取班级列表失败');
          }
        }
      } catch (e) {
        this.classList = [];
        if (this.$message) {
          this.$message.error('获取班级列表失败');
        }
      } finally {
        this.loadingClasses = false;
      }
    },
  },
  created() {
  },
  mounted() {
    this.loadClasses();
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);

  },
};
</script>
<style lang='less' scoped>
@import "./less/classTestMain.less";
.custom-select * {
  box-sizing: border-box;
}
.custom-select {
  position: relative;
  font-size: 48px;
  width:630px;
}
.custom-select .select-trigger {
  padding: 0 20px;
  border: 1px solid #dcdfe6;
  color: #606266;
  cursor: pointer;

  width: 630px;
  height: 110px;
  background: #FFFFFF;
  border-radius: 20px;
}
.custom-select.open .select-trigger {
  border-color: #409eff;
}
.custom-select .placeholder {
  font-size: 32px;
  color: #999999;
}
.custom-select .selected-text {
  font-size: 32px;
  color: #303133;
}
.custom-select .arrow {
  margin-left: 8px;
  width: 24px;
  height: 12px;
}
.custom-select .clear-btn {
  display: block;
  width: 50px;
  height: 50px;
  margin-right: 20px;
}
.custom-select .clear-btn:hover {
  color: #606266;
}
.custom-select .dropdown {
  position: absolute;
  left: 0;
  right: 0;
  top: calc(100% + 20px);
  background: #fff;
  border: 2px solid #e4e7ed;
  border-radius: 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  z-index: 10;
  width: 630px;
  overflow: hidden;

}
.custom-select .search-box {
  padding:20px;
  border-bottom: 1px solid #f2f6fc;
}
.custom-select .search-input {
  width: 100%;
  height: 80px;
  padding: 0 20px;
  border: 2px solid #dcdfe6;
  border-radius: 10px;
  outline: none;
  line-height: 66px;
  &::placeholder {
    font-size:32px;
    line-height: 66px;
  }
}
.custom-select .option-list {
  max-height: 600px;
  overflow: auto;
}
.custom-select .option-item {
  padding:20px;
  font-size: 32px;
  cursor: pointer;
}
.custom-select .option-item:hover {
  background: #f5f7fa;
}
.custom-select .option-item.empty {
  color: #909399;
  cursor: default;
}
.custom-select .loading {
  padding: 10px 12px;
  color: #909399;
}
</style>
